import associate from './associate.png';
import consultant from './consultant.png';
import senior from './senior.png';
import principal from './principal.png';
import managingPrincipal from './managingPrincipal.png';

const images = {
  Associate: associate,
  Consultant: consultant,
  'Senior Consultant': senior,
  'Principal Consultant': principal,
  'Managing Principal': managingPrincipal,
};
export default images;
